import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertService } from './alerts.service';
import { AlertsSharedComponent } from './alerts.component';
import { AlertSharedComponent } from './alert/alert.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        AlertSharedComponent,
        AlertsSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        AlertsSharedComponent
    ],
    providers: [
        AlertService
    ]
})

export class AlertSharedModule {}
